/**
 * Food Pulse taglines — one central place so every FoodPulse page
 * pulls its own memorable line. Sourced from product spec.
 *
 * Home tagline is intentionally two lines (rendered stacked).
 */
export const FP_TAGLINES = {
  home: {
    line1: "Connecting People, Smarter Food & Stronger Communities.",
    line2: "Discover. Share. Save. Nourish.",
  },
  about:               "Building a Better Food Future Together.",
  food_discovery:      "Find Great Food Near You.",
  restaurants:         "Taste the Best Around You.",
  recipes:             "Cook Smarter. Eat Better.",
  healthy_eating:      "Small Choices. Healthier Lives.",
  nutrition:           "Knowledge for Every Bite.",
  food_deals:          "Save More. Waste Less.",
  coupons:             "Delicious Savings Every Day.",
  food_waste:          "Rescue Food. Protect Our Planet.",
  food_assistance:     "Helping Food Reach Those Who Need It Most.",
  food_charities:      "Together Against Hunger.",
  volunteer:           "Give Your Time. Feed Hope.",
  farmers:             "Connecting Farms to Families.",
  supermarkets:        "Fresh Savings. Smarter Shopping.",
  groceries:           "Everything Fresh, Close to Home.",
  farmers_markets:     "Fresh from the Farm to Your Table.",
  food_banks:          "Sharing Food. Sharing Hope.",
  events:              "Celebrate Food. Celebrate Community.",
  cooking_classes:     "Learn. Cook. Inspire.",
  food_news:           "Stay Informed. Eat Smarter.",
  reviews:             "Real Experiences. Trusted Recommendations.",
  marketplace:         "Buy. Sell. Share. Sustain.",
  community:           "Where Food Brings People Together.",
  discussion_boards:   "Ask. Share. Learn.",
  ai_food_assistant:   "Your Personal Food Companion.",
  food_pantry:         "Know What You Have. Waste Less.",
  shopping_lists:      "Plan Better. Shop Smarter.",
  meal_planning:       "Healthy Meals Made Easy.",
  food_donations:      "Turn Surplus into Smiles.",
  emergency_food:      "Support When It Matters Most.",
  sustainability:      "Good for You. Good for the Planet.",
  partner_with_us:     "Together We Can End Food Waste.",
  contact_us:          "We're Here to Help.",

  // Business directory + Encyclopedia sub-pages we've already built.
  businesses:          "Every US food business, one open directory.",
  encyclopedia:        "Every food, one living reference.",

  // Category-shelf headlines (matches FoodPulseArticles hero variants).
  vegetables_category: "Everyday greens, everyday miracles.",
  fruits_category:     "From orchard to your kitchen.",
  news_category:       "The community, told in food.",

  // Mission line for footer / About.
  mission:
    "Food Pulse empowers people to discover food, find daily deals, save money, reduce waste, build food knowledge, improve health, and strengthen communities through technology and meaningful local connections.",
};

// Inspirational hero pool — for random hero rotations later.
export const FP_HERO_HEADLINES = [
  "Making Every Meal Count",
  "The World's Food Community",
  "Discover Food. Share Kindness.",
  "Reducing Food Waste Through Connection",
  "AI for a Healthier Food Future",
  "Where Communities Meet Around Food",
  "Food Intelligence for Everyone",
  "One Platform. Endless Food Possibilities.",
  "Eat Better. Live Better. Together.",
  "The Future of Food is Connected.",
];
